var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AdditionFieldsForm',{attrs:{"definition":_vm.freeFieldDefinition,"disabled":_vm.disabled,"data":_vm.recordingEvent.add_field_data}})
}
var staticRenderFns = []

export { render, staticRenderFns }